module.exports = __webpack_public_path__ + "media/images/khqr_footer_logo_0_5x-1f9e8160724db79e3ec9d272e9a3b961.png";